export function pagination(state = 1, action) {
  if (action.type === 'GET_PAGE') {
    return action.page;
  }

  return state;
}
